"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHandleUrlParams = void 0;
const react_router_dom_1 = require("react-router-dom");
const useHandleUrlParams = (params) => {
    const [searchParams] = (0, react_router_dom_1.useSearchParams)();
    params.forEach(({ parameter, callback }) => {
        if (searchParams.has(parameter)) {
            callback(searchParams.get(parameter));
        }
    });
};
exports.useHandleUrlParams = useHandleUrlParams;
